export function RouteTypeIndicator({GRoute, style}) {
    function getRouteIco(route_type) {
        switch (route_type) {
            case 0: return "fa-solid fa-train-tram";
            case 1: return "fa-solid fa-train-subway";
            case 2: return "fa-solid fa-train";
            case 3: return "fa-solid fa-bus";
            case 4: return "fa-solid fa-ferry";
            case 6: return "fa-solid fa-cable-car";
            default: return "fa-solid fa-route";
        }
    }    

    return (
        <span style={{
            opacity: (GRoute.suspended) ? '0.5' : '1',
            display: 'inline-block',
            margin: '2px',
            ...style
        }}>
            <i className={getRouteIco(GRoute.route_type)}></i>
        </span>
    );
}